/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jan 12 2024
 **/

import { CSSProperties } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button, Icon } from "@/frameworks/designStuff/components";
import { Maybe } from "@/frameworks/libraries/components";
import { _T } from "@rfice/language";

const alignStyle = (direction: "center" | "right"): CSSProperties => {
	return {
		position: "absolute",
		bottom: "8px",
		right: `${direction === "center" ? "50%" : "8px"}`,
		transform: `translateX(${direction === "center" ? "50%" : "0"})`
	};
};

export default function ScrollButton({
	newMessage,
	arrow,
	onClick
}: {
	newMessage: boolean;
	arrow: boolean;
	onClick: () => void;
}) {
	if (!newMessage && !arrow) return;
	return (
		<>
			<Maybe test={newMessage}>
				<ButtonMessage
					filled="neutral"
					shape="circle"
					size="small"
					onClick={onClick}
					endEnhancer={<Icon name="Down24" size={16} />}
					style={alignStyle("right")}
				>
					{_T("새 메세지")}
				</ButtonMessage>
			</Maybe>
			<Maybe test={arrow}>
				<ButtonIconMessage
					name="Down24"
					size="medium"
					shape="circle"
					onClick={onClick}
					style={alignStyle("right")}
				/>
			</Maybe>
		</>
	);
}
const buttonStyle = css`
	border-radius: 100px;
	border: 1px solid #e1e3e8 !important;
	background: #edeef1 !important;
	box-shadow:
		0px 0px 4px 0px rgba(0, 0, 0, 0.04),
		0px 8px 12px 0px rgba(0, 0, 0, 0.12);
	&:hover {
		border: 1px solid #caced4 !important;
		background: #e1e3e8 !important;
	}
`;
export const ButtonMessage = styled(Button)`
	${buttonStyle}
`;

export const ButtonIconMessage = styled(Button.Icon)`
	${buttonStyle}
`;
